<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    class="trash-icon"
    :style="{ '--icon-color': color }"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <path d="M3 6h18" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [String, Number],
    default: 16,
  },
  color: {
    type: String,
    default: '#dc3545',
  },
})
</script>

<style scoped>
.trash-icon {
  display: inline-block;
  vertical-align: middle;
  transition: opacity 0.2s;
  color: var(--icon-color, #dc3545);
}

.trash-icon:hover {
  opacity: 0.8;
}
</style>

<style>
/* Make icon white when inside buttons */
a.btn-link .trash-icon,
a.btn-sm .trash-icon,
button.btn-sm .trash-icon,
button.btn-primary .trash-icon,
button.btn-danger .trash-icon {
  color: white !important;
}
</style>
